exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media print {\n  ::ng-deep .mat-horizontal-stepper-header-container {\n    display: none !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/stages/stages.component.scss
// module id = ZMFu
// module chunks = 2